var React = require('react');

function TransactionSeparatorIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.894 5.006a.75.75 0 1 0 0 1.5v-1.5zm16.072.75v.75a.75.75 0 0 0 .507-1.302l-.507.552zm-4.017-4.703a.75.75 0 0 0-1.014 1.106l1.014-1.106zM.894 6.506h16.072v-1.5H.894v1.5zm16.579-1.302l-4.524-4.15-1.014 1.105 4.524 4.15 1.014-1.105zM16.966 9.487a.75.75 0 0 0 0-1.5v1.5zM.894 8.737v-.75A.75.75 0 0 0 .387 9.29l.507-.553zm4.017 4.704a.75.75 0 1 0 1.014-1.106L4.911 13.44zm12.055-5.454H.894v1.5h16.072v-1.5zM.387 9.29l4.524 4.15 1.014-1.105-4.523-4.15L.387 9.29z","fill":"#2C6774"}));
}

TransactionSeparatorIcon.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = TransactionSeparatorIcon;

TransactionSeparatorIcon.default = TransactionSeparatorIcon;
